const rememberMe = {
  rememberMe: {
    value: false,
    error: null,
    name: 'rememberMe',
    placeholder: 'Remember me',
    breed: 'checkbox',
    touched: false,
    isRequired: false,
    validationType: null,
    hasBlurred: false,
    inputType: 'checkbox',
		extraClass: 'checkbox__right'
  }
}


export default rememberMe;



/** WEBPACK FOOTER **
 ** ./src/forms/member/rememberMe.js
 **/